import React from 'react';
import { isMobile } from '@mightybyte/rnw.utils.device-info';
import { PopupV2 } from '../PopupV2';
import { View, Text, StyleSheet } from 'react-native';
import ButtonGeneral from '../ButtonGeneral';
import { YourPoints } from '../YourPoints';
import { TrophyBadge } from '../../../resources/svgComponents/badgeComponents/TrophyBadge';

type TAssessmentResultPopUp = {
  title: string;
  description: string;
  subtitle: string;
  onClose: () => void;
  positive: boolean;
  visible: boolean;
  setVisible: (value: boolean) => void;
  practice?: boolean;
  buttonFunction1?: () => void;
  buttonFunction2?: () => void;
  buttonText1?: string;
  buttonText2: string;
  showTrophy?: boolean;
};

export default function AssessmentResultPopUp(props: TAssessmentResultPopUp) {
  const {
    title,
    description,
    subtitle,
    positive,
    visible,
    setVisible,
    practice,
    buttonFunction1 = () => {},
    buttonFunction2 = () => {},
    buttonText1 = '',
    buttonText2 = '',
    showTrophy,
  } = props;
  return (
    <PopupV2
      title={title}
      visible={visible}
      setVisible={setVisible}
      height={isMobile ? 387 : 426}
      hexagonHeight={isMobile ? 54 : 62}
      hexagonWidth={isMobile ? 252 : 346}
      hideCloseButton={true}
      closeOnBackdropPress={false}
      hexagonColor={!positive ? ['#747474', '#1F1F1F'] : undefined}
    >
      <View style={[styles.card]}>
        <View style={[styles.content, { marginTop: isMobile ? 33 : 26 }]}>
          <Text style={[styles.subtitle, { fontSize: isMobile ? 18 : 24 }]}>{subtitle}</Text>
          <Text style={[styles.description, { fontSize: isMobile ? 14 : 16 }]}>{description}</Text>
          {showTrophy && (
            <View style={{ marginTop: 20 }}>
              <TrophyBadge />
            </View>
          )}
        </View>

        <View
          style={[styles.buttonContainer, { height: isMobile ? 80 : 102, gap: isMobile ? 8 : 12 }]}
        >
          {practice && (
            <ButtonGeneral
              onPress={() => {
                setVisible(false);
                buttonFunction1();
              }}
              title={buttonText1}
              height={isMobile ? 48 : 58}
              width={isMobile ? (!practice ? 151 : 151) : 201}
              fontSize={isMobile ? 14 : 16}
              colors={['#FEDD88', '#FEDD88']}
              nameContainerStyle={{
                borderColor: 'white',
                borderWidth: 2,
                marginRight: isMobile ? 10 : 0,
              }}
            />
          )}
          <ButtonGeneral
            onPress={() => {
              setVisible(false);
              buttonFunction2();
            }}
            title={buttonText2}
            height={isMobile ? 48 : 58}
            width={
              isMobile
                ? positive
                  ? !practice
                    ? 200
                    : 151
                  : 104
                : positive && !practice
                ? 411
                : 201
            }
            fontSize={isMobile ? 14 : 16}
          />
        </View>
      </View>
    </PopupV2>
  );
}

const styles = StyleSheet.create({
  card: {
    overflow: 'hidden',
    flexDirection: 'column',
    height: '100%',
  },

  content: {
    alignItems: 'center',
    paddingHorizontal: 60,
    paddingTop: 30,
    flex: 1,
  },

  subtitle: {
    fontFamily: 'Secular One',
    fontWeight: '400',
    textAlign: 'center',
    marginBottom: 8,
    color: '#000000',
  },
  description: {
    fontFamily: 'Secular One',
    color: '#453B3B',
    textAlign: 'center',
    fontWeight: '700',
  },
  buttonContainer: {
    justifyContent: 'center',
    backgroundColor: '#FEDD88',
    alignItems: 'center',
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    flexDirection: 'row',
  },

  pointsContainer: {
    width: 233,
    marginTop: 18,
    justifyContent: 'center',
  },
  badgeContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 12,
  },
  badgeText: {
    fontWeight: '400',
    fontSize: 16,
    color: '#8C8C8C',
  },
  ribbonContainer: {
    marginTop: 10,
  },
});
